import {
  Button,
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
} from "@mui/material";

const VariableGameLevelSelect = () => {
  const levels = [
    {
      title: "Easy",
      description: "3 variables (A, B, C) with numbers 1-9",
      path: "/variable-game-easy",
      color: "#4caf50",
    },
    {
      title: "Intermediate",
      description: "Variables with simple relationships (e.g., A + 1)",
      path: "/variable-game-intermediate",
      color: "#ff9800",
    },
    {
      title: "Advanced",
      description: "Complex variable relationships and chain calculations",
      path: "/variable-game-advanced",
      color: "#f44336",
    },
  ];

  const handleLevelClick = (path: string) => {
    document.location.href = path;
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen p-4">
      <Typography variant="h3" component="h1" gutterBottom>
        Variable Game
      </Typography>

      <Typography
        variant="h6"
        component="p"
        sx={{ mb: 4, textAlign: "center" }}
      >
        Choose your difficulty level
      </Typography>

      <Grid container spacing={3} sx={{ maxWidth: "900px" }}>
        {levels.map((level) => (
          <Grid item xs={12} sm={4} key={level.title}>
            <Card
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                transition: "transform 0.2s",
                "&:hover": {
                  transform: "scale(1.05)",
                  cursor: "pointer",
                },
              }}
              onClick={() => handleLevelClick(level.path)}
            >
              <CardContent sx={{ flexGrow: 1, textAlign: "center" }}>
                <Typography
                  variant="h4"
                  component="h2"
                  sx={{ color: level.color, mb: 2, fontWeight: "bold" }}
                >
                  {level.title}
                </Typography>
                <Typography variant="body1" color="text.secondary">
                  {level.description}
                </Typography>
                <Box sx={{ mt: 3 }}>
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: level.color,
                      "&:hover": {
                        backgroundColor: level.color,
                        opacity: 0.8,
                      },
                    }}
                  >
                    Select {level.title}
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Box sx={{ mt: 4, textAlign: "center", maxWidth: "600px" }}>
        <Typography variant="body2" color="text.secondary">
          Test your memory by recalling variable values. Each level increases in
          difficulty!
        </Typography>
      </Box>
    </div>
  );
};

export default VariableGameLevelSelect;
